import { useCallback } from 'react';
import { useParams } from 'react-router';

export const useNavigateToEmailTemplates = () => {
  const { siteId } = useParams<{ siteId: string }>();

  return useCallback(
    (openSubjectLinesTab = true) => event =>
      window.open(`/sites/${siteId}/designs/templates/email?fromOnsiteSMB=${openSubjectLinesTab}`, '_blank'),
    [siteId],
  );
};
